var map = {
	"./values-collaboration.gif": "2d4e",
	"./values-innovation.gif": "3376",
	"./values-integrity.gif": "9105",
	"./values-responsiveness.gif": "fdc7",
	"./values-service.gif": "58c1",
	"./values-stewardship.gif": "1303"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf2d";